'use client';

import { useRouter } from 'next/navigation';

import { STATE_FULL_NAMES } from 'utilities/states';

interface StateSelectorProps {
  basePath: string;
}

export default function StateSelector({ basePath }: StateSelectorProps) {
  const router = useRouter();

  return (
    <form className="my-4 min-[539px]:hidden">
      <fieldset>
        <label htmlFor="state-selector">Filter by state</label>
        <select
          id="state-selector"
          className="mt-1 w-full rounded-md border-stone-200 shadow-xs focus:border-pink-700 focus:ring-3 focus:ring-pink-200/50 dark:border-stone-700 dark:bg-stone-950 dark:text-white dark:focus:border-amber-400 dark:focus:ring-amber-400/30"
          onChange={(e) => {
            if (e.target.value) {
              router.push(`${basePath}/explore/${e.target.value}`);
            }
          }}
        >
          <option value="">Choose a state</option>
          {Object.entries(STATE_FULL_NAMES).map(([state, stateName]) => (
            <option value={state} key={state}>
              {stateName}
            </option>
          ))}
        </select>
      </fieldset>
    </form>
  );
}
